import { sa } from '../helpers/sa'

import type { BeginCheckoutSchemaInput } from '@loc/server/interface/track/trackEventParams.common'
import type { ITrackCoreProps } from '.'
import type { TrackCustomEventProps } from '..'
import type { ICoreItem } from './type'

export const useTrackBeginCheckout = ({
  eventTracking,
}: ITrackCoreProps): ICoreItem<BeginCheckoutSchemaInput> => {
  const trackEvent = async (
    props: BeginCheckoutSchemaInput & TrackCustomEventProps,
  ) => {
    const { name, meta, commonParamsLatest } = props

    const params = [{ name, meta, ...commonParamsLatest.commonParams }]

    sa.track(name, {
      ecommerce: meta,
      ...commonParamsLatest.gaCommonParams,
    })
    await eventTracking(params)
  }

  return {
    trackEvent,
  }
}
